import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatOption } from '@angular/material';
import { PropertyState, Region, Subregion } from './loanofficerregionreference.model';
import { LoanOfficerRegionReferenceService } from './loanofficerregionreference.service';
import { SubregionAddComponent } from './subregion-add/subregion-add.component';

@Component({
    selector: 'app-loanofficerregionreference',
    templateUrl: './loanofficerregionreference.component.html',
    styleUrls: ['./loanofficerregionreference.component.css']
})
export class LoanOfficerRegionReferenceComponent implements OnInit {

    @ViewChild('allSelected') private allSelected: MatOption;
    public loRegionReferenceForm: FormGroup;
    public regions: Region[];
    public propertyStates: PropertyState[];
    public tempsubregion: Subregion;
    public isLoading: boolean = false;
    public regionDisplay: string = "";
    public northOhio: string = "North Ohio";
    public southOhio: string = "South Ohio";

    constructor(private dialog: MatDialog, private fb: FormBuilder,
        private service: LoanOfficerRegionReferenceService) { }

    ngOnInit() {
        this.getRegions();
        this.getPropertyStates();
        this.loRegionReferenceForm = this.fb.group({
                state: [null, Validators.required]
        });
    }

    getRegions() {
        var underwriterGroupName = "Underwriting";
        this.service.getRegionAssignmentStrategiesByGroup(underwriterGroupName).then(
            result => {
                result.sort((a, b) => a.name.localeCompare(b.name));
                this.regions = JSON.parse(JSON.stringify(result));
            }
        )
    }

    getPropertyStates() {
        this.service.getPropertyStates().then(
            result => {
                var allPropertyStates = JSON.parse(JSON.stringify(result));
                var validRegionIds = this.regions.map(x => x.id);

                allPropertyStates.filter(state => state.subjectPropertyStateName != undefined);
                allPropertyStates.sort((a, b) => a.subjectPropertyStateName.localeCompare(b.subjectPropertyStateName));

                this.propertyStates = allPropertyStates.filter(state => validRegionIds.includes(state.regionId))
            }
        )
    }

    getRegion() {
        if (this.loRegionReferenceForm.value.state != null) {
            var regionId = this.loRegionReferenceForm.value.state.regionId;
            var selectedRegion = this.regions.find(region => region.id == regionId);
            this.regionDisplay = selectedRegion.name + " Region";
        }
    }

    openAddSubregionAssignmentDialog(subregionName : string) {
        this.dialog.open(SubregionAddComponent,
            {
                data: subregionName,
                height: "340px",
                width: "410px"
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/loanofficerregionreference.component.ts